import script from "./DashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./DashboardPage.vue?vue&type=style&index=0&id=eade6590&lang=css"

const __exports__ = script;

export default __exports__